import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { DropdownInputComponent } from '../../inputs/dropdown-input/dropdown-input.component';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { DropdownItem } from '../../models/dropdown-item';

@Component({
  selector: 'lib-dropdown-form-field',
  imports: [ReactiveFormsModule, DropdownInputComponent, FormErrorComponent],
  templateUrl: './dropdown-form-field.component.html',
  styleUrl: './dropdown-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input.required<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  clearable = input<boolean>(false);
  dropdowns = input<DropdownItem[]>([]);
  inputId: string = uuidv4();
}
